import React, { useState } from 'react';
import { getDatabase, ref, set } from 'firebase/database';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faUndo } from '@fortawesome/free-solid-svg-icons';
const Transactions = props => {
	const handleDeleteTransaction = async (key, tableKey) => {
		const db = getDatabase();
		try {
			await set(ref(db, 'transactions/' + tableKey + '/' + key), {});
			let filteredTransactions = props.data.transactions.filter(transaction => transaction.key !== key);
			props.data.setTransactions([...filteredTransactions]);
		} catch (error) {
			console.error(error);
		}
	};

	const Transaction = props => {
		const [toggleFlip, setToggleFlip] = useState(false);

		return (
			<div class='cardBox'>
				<div class={`card ${toggleFlip ? 'Rotated' : ''}`}>
					<div class='front' onClick={() => setToggleFlip(prevToggleFlip => !prevToggleFlip)}>
						<div>{props.transaction.table.number}</div>
						<div>{props.transaction.sum.toFixed(2) + '€'}</div>
					</div>
					<div class='back'>
						<div onClick={() => handleDeleteTransaction(props.transaction.key, props.transaction.table.key)}>
							<FontAwesomeIcon icon={faTrashAlt} />
						</div>
						<div onClick={() => setToggleFlip(prevToggleFlip => !prevToggleFlip)}>
							<FontAwesomeIcon icon={faUndo} />
						</div>
					</div>
				</div>
			</div>
		);
	};
	return props.data.transactions.length > 0 ? (
		<section className='Flips'>
			<div class='boxesContainer'>
				{props.data.transactions.map(transaction => {
					return <Transaction transaction={transaction} />;
				})}
			</div>
		</section>
	) : null;
};
export default Transactions;
